import React from 'react';
import { FileImportView } from './components';
import { useFileImport } from './useFileImport';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';

/**
 * /purchases/file-import — the Excel-import confirmation page: the manual-
 * import form pre-populated from the analyzed file, plus the Doubtful imports
 * review card. Reached only via the Excel-import modal; a direct visit or
 * refresh finds no pending analysis and redirects back to /purchases (the
 * hook navigates; this container renders nothing meanwhile).
 */
export const FileImport: React.FC = () => {
    const fileImport = useFileImport();

    if (!fileImport.isReady) {
        return null;
    }

    return (
        <div
            className="mx-auto flex w-full max-w-7xl flex-col gap-8"
            {...getNodeTestIdProp('file-import-page')}
            id="file-import-page"
        >
            <FileImportView fileImport={fileImport} />
        </div>
    );
};
